import { SPage } from "src/components/spage";
import { AccountProfileDetails } from "src/pages/profile/account-profile-details";

export const ProfilePage = () => (
  <SPage title="Profile" pageTitle="Account">
    <AccountProfileDetails />
  </SPage>
);
